module.exports = __webpack_public_path__ + "static/media/logo-meep.4cbc3953.png";